import { render, staticRenderFns } from "./gj-text-alert.vue?vue&type=template&id=2cfb8c1d&scoped=true&"
import script from "./gj-text-alert.vue?vue&type=script&lang=js&"
export * from "./gj-text-alert.vue?vue&type=script&lang=js&"
import style0 from "./gj-text-alert.vue?vue&type=style&index=0&id=2cfb8c1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb8c1d",
  null
  
)

export default component.exports